<div
  *ngIf="field?.options"
  class="custom-multiselect form-group"
  [formGroup]="form"
  [ngClass]="[field?.class, field?.customMultiselectConfig?.useCardView ? 'custom-card-view' : '']"
  >
  <label>{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <p-multiSelect
    #multiSelect
    [options]="filteredOptions"
    [display]="field?.customMultiselectConfig?.isCommaSeparated ? 'comma' : 'chip'"
    [optionLabel]="field?.customMultiselectConfig?.optionLabel"
    [defaultLabel]="field?.customMultiselectConfig?.defaultLabel"
    [dataKey]="field?.customMultiselectConfig?.dataKey"
    [showToggleAll]="false"
    [filter]="false"
    [showClear]="false"
    [formControlName]="field?.name"
    [maxSelectedLabels]="1"
    [selectedItemsLabel]="'{0} selected'"
  >
  <ng-template let-item pTemplate="item">
    <ng-container *ngIf="field?.customMultiselectConfig?.useCardView; else defaultItem">
      <div class="resource-card-item">
        <div
          class="cardsNFTS"
          [ngClass]="{ 'has-image': !!item[field?.customMultiselectConfig?.optionIconLabel] }"
        >
          <div class="cardsNFTS-image">
            <img
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="item[field?.customMultiselectConfig?.optionIconLabel]"
              [src]="item[field?.customMultiselectConfig?.optionIconLabel]"
              [format]="'webp'"
              alt="Option Icon"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="cardsNFTS-title">
            <h5 class="word-length" *ngIf="field?.customMultiselectConfig?.optionLabel">
              {{ item[field?.customMultiselectConfig?.optionLabel] }}
            </h5>
            <p *ngIf="!!field?.customMultiselectConfig?.optionPrice">
              {{ item[field?.customMultiselectConfig?.optionPrice] | currency }}
              <ng-container *ngIf="field?.customMultiselectConfig?.optionSubLabel && item[field?.customMultiselectConfig?.optionSubLabel]">
                |
                <span class="link-text">{{item[field?.customMultiselectConfig?.optionSubLabel]}}</span>
              </ng-container>
            </p>
            <p  *ngIf="!!field?.customMultiselectConfig?.optionDate && item[field?.customMultiselectConfig?.optionDate] ">
              {{ item[field?.customMultiselectConfig?.optionDate] | date:'MMM d, yyyy' }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  
    <ng-template #defaultItem>
      <div class="item-label-cls">
        <img
          *ngIf="field?.customMultiselectConfig?.optionIconLabel && !field?.customMultiselectConfig?.isIcon"
          class="icon-cls"
          [src]="item[field?.customMultiselectConfig?.optionIconLabel]"
          alt="icon"
        />
        <em 
        *ngIf="field?.customMultiselectConfig?.optionIconLabel && field?.customMultiselectConfig?.isIcon"
        [class]="item[field?.customMultiselectConfig?.optionIconLabel]"></em>
        <div class="icon-label">
          {{ item[field?.customMultiselectConfig?.optionLabel] }}
        </div>
      </div>
    </ng-template>
  </ng-template>
  
    <ng-template
      *ngIf="field?.customMultiselectConfig?.showHeader"
      pTemplate="header"
    >
      <div class="custom-search-container">
        <em class="icon-liteicons-search"></em>
        <input
          type="text"
          pInputText
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterOptions()"
          [ngModelOptions]="{ standalone: true }"
          [placeholder]="field?.customMultiselectConfig?.filterLabel"
          class="custom-search-input"
        />
      </div>
      <div class="select-all-container" *ngIf="!searchTerm && field?.customMultiselectConfig?.selectAllButtonLabel">
        <p-checkbox
          binary="true"
          [ngModel]="allSelected"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="toggleAll($event)"
        ></p-checkbox>
        <label class="mb-0">
          {{ field?.customMultiselectConfig?.selectAllButtonLabel }}
        </label>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="buttons">
        <button
          *ngIf="field?.customMultiselectConfig?.customButtonLabel"
          type="button"
          class="custom-btn"
          (click)="customBtnClick(multiSelect)"
        >
          {{ field?.customMultiselectConfig?.customButtonLabel }}
        </button>
        <div class="right">
          <button
            *ngIf="field?.customMultiselectConfig?.cancelButtonLabel"
            type="button"
            class="btn btn-default"
            (click)="closeMultiSelect(multiSelect)"
          >
            {{ field?.customMultiselectConfig?.cancelButtonLabel }}
          </button>
          <button
            *ngIf="field?.customMultiselectConfig?.confirmButtonLabel"
            type="button"
            class="btn btn-primary"
            (click)="confirm(multiSelect)"
          >
            {{ field?.customMultiselectConfig?.confirmButtonLabel }}
          </button>
        </div>
      </div>
    </ng-template>
  </p-multiSelect>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
